import React, { PropTypes } from 'react';

import {NitroIcon} from 'nitro-components';
import styled from 'styled-components';

const Action = styled.span`
  font-size: 12px;
  color: ${props => props.theme.color.secondary};
`;

const GriddleAction = ({ content }) => {
  return (
    <Action>
      {content}
      {' '}
      <NitroIcon clickable variant="secondary" size={8} name="arrow-right" />
    </Action>
  );
};

GriddleAction.propTypes = {
  content: PropTypes.string
};

export default GriddleAction;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/GriddleAction.js